import { query_feedback_info_list } from '@/api/mjstore-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
} from '@/components/page-model2/mjstore/mjstore-feedbackinfo-config1';

import { reactive } from 'vue';

const None = null;

const search_config: SearchConfig = {
  settings: {},
  fields: [],
  rules: {},
  model: reactive({}),
};
const search_options = {};

const edit_model_config: SearchConfig = {
  settings: {},
  fields: [],
  rules: {},
  model: reactive({}),
};
const edit_model_config_options = {};

const update_model_config: SearchConfig = {
  settings: {},
  fields: [],
  rules: {},
  model: reactive({}),
};
const update_model_config_options = {};

const titleList = {
  title: '撤单管理',
  addModalTitle: '新建撤单',
  updateTitle: '修改撤单',
  is_create: false, // 是否有【新建】按钮
  is_update: false, // 是否有【修改】按钮
  is_remove: false, // 是否有【删除】按钮
  is_recover: false, // 是否有【恢复】按钮
};

const api_fields: Record = {};

const baseColumns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
    slots: { customRender: 'index' },
  },
  {
    title: '诉求号',
    width: 170,
    dataIndex: 'require_info__code',
    checked: true,
  },
  {
    title: '回访日期',
    width: 150,
    dataIndex: 'date',
    checked: true,
    slots: { customRender: 'datetime' },
  },
  {
    title: '回访内容',
    width: 150,
    dataIndex: 'content',
    checked: true,
  },
  {
    title: '执行门店',
    width: 150,
    dataIndex: 'shop__name',
    checked: true,
  },
  {
    title: '执行人',
    width: 150,
    dataIndex: 'staff__name',
    checked: true,
  },
  {
    title: '创建日期',
    width: 150,
    dataIndex: 'create_time',
    checked: true,
    slots: { customRender: 'datetime' },
  },
  {
    title: '操作',
    width: 100,
    dataIndex: 'action',
    checked: true,
    slots: { customRender: 'action' },
    fixed: 'right',
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);

export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_feedback_info_list,
    addData: None,
    updateData: None,
    removeData: None,
    recoverData: None,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
